'use client';
import AppLayout from '@/components/AppLayout';
import KYCIntakeScreen from './components/KYCIntakeScreen';

export default function KYCIntakePage() {
  return (
    <AppLayout portalName="KYC / KYB Intake" portalRole="compliance">
      <KYCIntakeScreen />
    </AppLayout>
  );
}
